// 한국어 UI 문구. 업무 모드(stealth)에서 평범한 업무 용어로 바뀌는 항목은 *Work 키로 둔다.
// 전체 키 구조·용어집은 docs/spec/i18n.md를 따른다(여기는 웹 셸에 필요한 최소 집합).
export default {
  header: {
    workMode: '업무 모드',
    boss: 'Esc',
    bossHint: '누르면 바로 시트 화면으로',
    settings: '설정',
    animation: '애니메이션',
  },
  nav: {
    reply: '답장', replyWork: '초안',
    map: '회사 지도', mapWork: '이해관계자 맵',
    diary: '일기장', diaryWork: '메모',
    manage: '사람·조직 관리', manageWork: '연락처 관리',
    cardLink: '성향 카드', pickLabel: '누구에게 답장할까요?', done: '완료',
  },
  map: {
    rel: '내 관계', relWork: '영향도',
    org: '조직도',
    friend: '친함', friendWork: '협력',
    tension: '긴장', tensionWork: '이슈',
    reportLine: '보고라인',
    writePlaceholder: '오늘 회사에서 무슨 일 있었어요?',
    writePlaceholderWork: '메모 추가…',
    writeButton: '기록',
    writeHint: '사람 이름을 넣어 한 줄만 써도 돼요. 두 사람을 같이 쓰면 관계를 찾아요.',
  },
  left: {
    people: '회사 사람 · 가까운 순', peopleWork: '연락처',
    meLevel: '나 · Lv.{lv}',
    meCount: '기록 {n}개 · 다음 레벨까지 {left}개',
  },
  diary: {
    safe: '이 기기에만 암호화해서 저장돼요',
    placeholder: '오늘 회사에서 무슨 일 있었어요? 이름을 쓰면 자동으로 태그돼요 (⌘/Ctrl+Enter로 저장)',
    save: '저장', all: '전체', empty: '아직 기록이 없어요', today: '오늘', yesterday: '어제',
    rec: '녹음', recStop: '멈추기', cap: '캡처',
    recNote: '분석하지 않고 암호화 보관만 해요',
    ocrRun: 'AI로 읽어내기', ocrBusy: '읽는 중… (처음엔 좀 걸려요)', ocrTitle: 'AI가 읽어낸 내용',
    useReply: '이 대화로 답장 쓰기 →', noMic: '마이크를 쓸 수 없어요', ocrFail: '(읽어내지 못했어요)',
    tooShort: '너무 짧아요', voiceInsight: '음성 기록 +1', voiceSaved: '음성 {d} 저장됨', holdRec: '꾹 누르면 녹음',
  },
  manage: {
    tabPeople: '사람', tabOrg: '조직', tabRel: '관계',
    quickLabel: '한 줄로 추가', quickPlaceholder: '예) 영업팀 윤대리 대리, 박팀장 밑', add: '추가',
    peopleHint: '사람을 눌러 바로 고치세요. 바꾸는 즉시 암호화 저장되고 지도·목록에 반영돼요.',
    fName: '이름', fTitle: '직함', fTitlePlaceholder: '예) 영업팀장',
    fAliases: '일기에서 부르는 말 (쉼표로 구분 · AI에 보낼 때 가려져요)', fAliasesPlaceholder: '예) 박 팀장, 팀장님',
    fDept: '부서', fBoss: '보고하는 사람(상사)', fLevel: '직급 단계', fClose: '나와의 거리',
    fCompany: '회사', myCompany: '내 회사',
    companiesTitle: '고객사 · 외부 조직', addCompany: '+ 고객사 추가', newCompanyName: '새 고객사',
    far: '멀다', near: '가깝다', bossNone: '없음', me: '나', deptNone: '소속 없음',
    del: '삭제', delSure: '정말 삭제할까요? 한 번 더 누르세요',
    lv1: '임원', lv2: '팀장급', lv3: '과장·차장', lv4: '대리·주임', lv5: '사원',
    orgExec: '소속 없음 · 임원', memberN: '{n}명', addToDept: '+ 사람 추가 (이름 입력 후 Enter)', addDept: '+ 부서 추가',
    orgHint: '부서와 직급 단계만 정하면 조직도는 자동으로 그려져요.', newDeptName: '새 부서',
    relConfirmed: '내가 확인한 관계', relNone: '아직 관계가 없어요.', relAddTitle: '+ 관계 추가',
    relMemoPlaceholder: '메모 (예: 입사 동기)', pickTwo: '서로 다른 두 사람을 골라 주세요', relExists: '이미 있는 관계예요. 위에서 고쳐 주세요',
    typeFriend: '친함', typeWork: '동료', typeTension: '긴장',
    saved: '저장됨', nameExists: '이미 있는 이름이에요',
  },
  compose: {
    chat: '메신저', mail: '메일', situation: '상황',
    sit_status_late: '보고 지연', sit_ask_help: '부탁', sit_say_no: '거절', sit_nudge: '재촉', sit_apology: '사과', sit_thanks: '감사',
    incoming: '받은 메시지', incomingPlaceholder: '상대가 보낸 메시지를 붙여넣어요 (선택)',
    draft: '내 답장 초안', draftHint: '대충 써도 돼요', draftPlaceholder: '하고 싶은 말을 편하게 적어요',
    go: '말결로 다듬기', thinking: '말결 고르는 중',
    outFor: '{name}님께 맞춘 {kind}', kindChat: '답장', kindMail: '메일',
    copy: '복사', copied: '복사했어요', again: '다시 쓰기', good: '잘 통했어요',
    missing: '빠진 정보', engineNote: '엔진 · {engine}',
    simpleTitle: '지금은 간단 모드예요 · 확인해 보세요',
    simpleNote: 'AI가 쉬고 있어 규칙으로 점검했어요. 바꿀 부분만 짚어 드려요.',
    empty: '초안을 적고 다듬기를 눌러요.', allGood: '지금 초안도 이 분께 무난해요.',
  },
  simple: {
    d_conclusion_late: '결론(언제·무엇)이 첫 줄에 있나요?',
    d_over_apology: '사과가 여러 번이에요 · 한 번이면 충분해요',
    d_hedge: '돌려 말하는 표현이 있어요 (혹시, ~것 같은데)',
    d_no_deadline: '기한·날짜가 없어요',
    d_too_long: '메신저인데 길어요 · 짧게 나눠 보세요',
    d_emoji_mismatch: '이모지가 있어요 · 격식 있는 상대면 빼는 게 좋아요',
  },
  newp: {
    found: '새 이름 발견 · 추가할까요?', add: '추가', ignore: '무시',
    added: '{name} 추가 · 조직에서 위치를 정해보세요',
  },
  onb: {
    t0: '회사 사람에게\n맞춘 답장', d0: '상사·동료마다 다른 말투. 그 사람 성향에 맞춰 메신저·메일 답장을 다듬어 드려요.',
    t1: '기록이 쌓일수록\n정확해져요', d1: '사람마다 겪은 일을 한 줄씩 적으면 그게 곧 그 사람 프로필이 돼요. 음성·캡처도 돼요.',
    t2: '유출되면 끝.\n그래서 로컬 암호화', d2: '모든 기록은 이 기기에만 암호화 저장돼요. 서버로 가지 않고, 비밀번호를 잊으면 복구되지 않아요.',
    next: '다음', start: '시작하기', skip: '건너뛰기',
  },
  account: {
    title: '계정', signupTitle: '가입하기', deleteTitle: '회원 탈퇴', back: '뒤로',
    localOnly: '지금은 이 기기에만 저장돼요', whySignup: '가입하면 폰을 바꾸거나 잃어버려도 공략집을 되살릴 수 있어요. 가입하지 않아도 기본 기능은 모두 쓸 수 있어요.',
    signupBackup: '가입하고 백업하기', keepData: '가입하면 지금까지의 기록을 그대로 이어서 써요. 일기는 암호화되어 운영자도 볼 수 없어요.',
    pendingUntil: '탈퇴 대기 중 · {d}에 완전 삭제돼요', cancelDeletion: '탈퇴 취소',
    login: '로그인', plan: '구독', contribute: '데이터 기여 (선택)', logout: '로그아웃', delete: '회원 탈퇴',
    noName: '이름이나 전화번호는 받지 않아요.', apple: 'Apple로 계속하기', google: 'Google로 계속하기', soon: '준비 중',
    email: '이메일', sendCode: '로그인 코드 받기',
    codeSent: '{hint} 으로 코드를 보냈어요.', code: '인증 코드',
    agreeAll: '모두 동의', req: '필수', opt: '선택',
    terms: '이용약관', privacy: '개인정보 수집·이용', privacyNote: '로그인 식별자, 이메일(선택), 언어 · AI 처리와 서버가 해외(미국)에 있어요',
    age: '만 14세 이상이에요', contributeAgree: '앱 개선 돕기 (데이터 기여)', contributeNote: '문장·이름 없이 숫자만 · 언제든 끌 수 있어요',
    marketing: '소식 메일 받기', next: '다음',
    saveKey: '복구 키를 저장해 주세요', keyWhy: '일기는 이 키로만 열려요. 운영자도 열 수 없어서, 키를 잃어버리면 다른 기기에서 되살릴 수 없어요.',
    copy: '복사하기', savedKey: '안전한 곳에 저장했어요', finishSignup: '가입 완료',
    onDelete: '탈퇴하면', delSync: '서버의 동기화 데이터를 바로 지워요', del7d: '계정은 7일 뒤 완전히 삭제돼요. 그 전에 다시 로그인하면 취소할 수 있어요',
    delContrib: '기여한 익명 데이터도 삭제 요청을 함께 보내요', delBilling: '결제 기록만 법에 따라 계정 연결을 끊고 5년 보관해요',
    localQ: '이 기기의 일기는요?', localQnote: '계정과 상관없이 내 기기에 있는 기록이에요.', keep: '남겨 두기', wipe: '함께 지우기',
    whyLeave: '떠나는 이유를 알려 주실래요? (선택)', whyLeaveNote: '더 나은 앱을 만드는 데만 써요.',
    reason_rare: '잘 안 쓰게 돼요', reason_reply: '답장이 마음에 안 들어요', reason_privacy: '개인정보가 걱정돼요', reason_price: '비싸요', reason_other_app: '다른 앱을 써요', reason_left_job: '이직·퇴사했어요',
    reasonMore: '더 하고 싶은 말 (선택)', skip: '건너뛰기',
    lastCheck: '마지막으로 본인 확인', lastCheckNote: '로그인으로 한 번 더 확인한 뒤 탈퇴해요.', doDelete: '탈퇴하기',
    needRequired: '필수 동의가 필요해요', needCode: '인증 코드를 입력해 주세요', keyCopied: '복구 키를 복사했어요',
    signedUp: '가입했어요 · 지금까지의 기록을 그대로 이어서 써요', loggedOut: '로그아웃했어요 · 이 기기의 기록은 그대로예요',
    deletionCancelled: '탈퇴를 취소했어요', deletedWipe: '탈퇴를 요청했어요 · 이 기기의 기록도 지웠어요', deletedKeep: '탈퇴를 요청했어요 · 7일 안에 로그인하면 취소돼요',
    backup: '백업 · 복원', lastBackup: '마지막 백업 · {d}', noBackup: '아직 백업하지 않았어요', keyPlaceholder: '복구 키 12단어 (띄어쓰기)',
    backupNow: '지금 백업', restore: '이 기기로 복원', backedUp: '백업했어요 · 암호화되어 운영자도 못 열어요', restored: '복원했어요 · 기록 {n}개',
    keyWrong: '복구 키가 맞지 않아요', needKey: '복구 키가 필요해요(가입 때 받은 12단어)',
  },
  crisis: {
    title: '혼자가 아니에요',
    msg: '지금 많이 힘들다면, 이야기 나눌 곳이 있어요. 아래로 연락해 보세요.',
    note: '이 앱은 기록을 도울 뿐 전문 상담을 대신하지 않아요. 급할 땐 119.',
    close: '닫기',
  },
  lock: {
    setupTitle: '비밀번호 만들기',
    setupDesc: '기록은 이 기기에만, 비밀번호로 암호화해 저장돼요. 서버로 보내지 않아요.',
    unlockTitle: '잠금 해제',
    password: '비밀번호',
    confirm: '비밀번호 확인',
    warnLabel: '비밀번호를 잊으면 모든 기록을 복구할 수 없다는 걸 이해했어요.',
    create: '시작하기',
    creating: '만드는 중…',
    unlock: '열기',
    unlocking: '여는 중…',
    errWrong: '비밀번호가 맞지 않아요.',
    errMismatch: '두 비밀번호가 달라요.',
    errShort: '비밀번호는 최소 {n}자 이상이어야 해요.',
    errWarn: '복구 불가 안내에 동의해 주세요.',
    forgot: '비밀번호를 잊었어요 (전체 삭제하고 새로 시작)',
    forgotConfirm: '비밀번호는 복구할 수 없어요. 이 기기의 모든 기록을 지우고 새로 시작할까요? 되돌릴 수 없어요.',
  },
  settings: {
    settingsTitle: '설정', screen: '화면', security: '보안', disguise: '위장', data: '데이터', helpSec: '도움',
    theme: '테마', themeAuto: '시스템 따라', themeLight: '라이트', themeDark: '다크', language: '언어',
    autoLock: '자동 잠금', min1: '1분', min5: '5분', min15: '15분', min30: '30분', never: '안 함',
    curPw: '현재 비밀번호', newPw: '새 비밀번호', change: '비밀번호 변경', pwChanged: '비밀번호를 바꿨어요',
    pwWrong: '현재 비밀번호가 달라요', pwShort: '비밀번호는 최소 {n}자', lockNow: '지금 잠그기',
    wipe: '모든 기록 삭제', wipeConfirm: '정말 지울까요? 한 번 더 (되돌릴 수 없어요)',
    crisisOpen: '위기 안내 보기', version: '버전',
    title: '숨기기 설정',
    cover: '위장 화면',
    animationOpt: '애니메이션',
    animAuto: '업무 모드에서만 끄기', animOn: '항상 켜기', animOff: '항상 끄기',
    startCover: '열 때 위장 화면으로 시작',
    away: '창을 벗어나거나 자리를 비우면',
    awayCover: '위장 화면으로', awayVeil: '흐리게', awayNone: '그대로',
    idle: '자리 비움 기준',
    idle30: '30초', idle60: '1분', idle300: '5분', idle0: '사용 안 함',
    pin: '비밀번호',
    help: '숨기기: Esc 또는 마우스를 화면 왼쪽 위 구석으로. 다시 열기: 시트는 셀에 =비밀번호 + Enter, 나머지는 비밀번호 + Enter',
  },
  covers: {
    sheet: '스프레드시트', docs: '문서', mail: '메일함', kanban: '칸반 보드',
    memo: '메모장', calc: '계산기', weather: '날씨', todo: '할 일',
    howMemo: '“메모장” 제목을 길게 누르면 비밀번호 칸이 나와요',
    howCalc: '비밀번호(PIN) 입력하고 = 를 누르면 열려요 · 계산도 진짜로 돼요',
    howWeather: '기온 숫자를 길게 누르면 비밀번호 칸이 나와요',
    howTodo: '“할 일” 제목을 길게 누르면 비밀번호 칸이 나와요',
  },
  toast: {
    saved: '저장됨',
    animOff: '애니메이션을 껐어요',
    animOnStealth: '업무 모드에서도 애니메이션을 켰어요 · 주변 시선에 주의',
    animOn: '애니메이션을 켰어요',
    settingsSaved: '저장했어요',
  },
}
